import React, { FC, memo } from 'react';
import { Button, Dropdown, Menu } from 'udesk-ui';
import { ArrowDownSOutlined } from '@udesk/icons';
import UdeskLocales from 'UdeskLocales';

interface TemplateProps {
    productId?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { productId } = props;

    const MenuMap = {
        ProductStatistics: 'ProductStatistics',
        ProductInsight: 'ProductInsight',
        UseriInsight: 'UseriInsight',
    };

    const onCheckReport = (key: React.Key) => {
        if (!productId) {
            return;
        }

        if (key === MenuMap.ProductStatistics) {
            window.open(
                `/conversation-analysis/data-analysis/product-statistics?productId=${productId}`
            );
        } else if (key === MenuMap.ProductInsight) {
            window.open(
                `/conversation-analysis/data-analysis/product-insight?productId=${productId}`
            );
        } else if (key === MenuMap.UseriInsight) {
            window.open(`/conversation-analysis/data-analysis/user-insight?productId=${productId}`);
        }
    };

    return (
        <Dropdown
            overlay={
                <Menu onClick={(e) => onCheckReport(e.key)}>
                    <Menu.Item key={MenuMap.ProductStatistics}>
                        {/* 产品统计 */}
                        {
                            UdeskLocales['current'].pages.conversationAnalysis.productManage.list
                                .components.checkReportButton.index.productStatistics
                        }
                    </Menu.Item>
                    <Menu.Item key={MenuMap.ProductInsight}>
                        {/* 产品洞察 */}
                        {
                            UdeskLocales['current'].pages.conversationAnalysis.productManage.list
                                .components.checkReportButton.index.productInsights
                        }
                    </Menu.Item>
                    <Menu.Item key={MenuMap.UseriInsight}>
                        {/* 用户洞察 */}
                        {
                            UdeskLocales['current'].pages.conversationAnalysis.productManage.list
                                .components.checkReportButton.index.userInsights
                        }
                    </Menu.Item>
                </Menu>
            }
        >
            <Button size="small" type="link">
                {/* 查看报告 */}
                {
                    UdeskLocales['current'].pages.conversationAnalysis.productManage.list.components
                        .checkReportButton.index.viewReport
                }
                <ArrowDownSOutlined />
            </Button>
        </Dropdown>
    );
});

export default Template;
